import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=011829be&"
import script from "./Main.vue?vue&type=script&lang=ts&"
export * from "./Main.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Main.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsItems } from 'vuetify/lib'
installComponents(component, {VBadge,VTab,VTabItem,VTabs,VTabsItems})
